import { z } from 'zod';
import { BackendCompatibleLocales } from '../../enums';
import { CanvasImageValue } from '../../types/utils';

// A language the admin opened but left empty is registered as `undefined`, not absent.
const translations = z.partialRecord(
  z.enum(BackendCompatibleLocales),
  z.string().optional()
);

export const ExperienceGroupFormValidatorSchema = z.object({
  name: translations.refine((name) => !!name.en?.trim(), {
    message: 'experience_group_name_required',
  }),
  // The server drops a description that has no English text, so require it up front.
  description: translations.refine(
    (description) =>
      !Object.values(description).some((text) => text?.trim()) ||
      !!description.en?.trim(),
    { message: 'experience_group_description_default_locale_required' }
  ),
  /** A cropped canvas not yet uploaded, or the URL of the saved picture. */
  headerImage: z.custom<CanvasImageValue | string>().optional(),
});

export type ExperienceGroupFormValidator = z.infer<
  typeof ExperienceGroupFormValidatorSchema
>;
